import { render, staticRenderFns } from "./SummaryBannerSection.vue?vue&type=template&id=6c040abe"
import script from "./SummaryBannerSection.vue?vue&type=script&lang=ts"
export * from "./SummaryBannerSection.vue?vue&type=script&lang=ts"
import style0 from "./SummaryBannerSection.vue?vue&type=style&index=0&id=6c040abe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports